import { render, staticRenderFns } from "./HorizontalTimeline.vue?vue&type=template&id=64fabf58"
import script from "./HorizontalTimeline.vue?vue&type=script&lang=js"
export * from "./HorizontalTimeline.vue?vue&type=script&lang=js"
import style0 from "./HorizontalTimeline.vue?vue&type=style&index=0&id=64fabf58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports